
import type { PropType } from 'vue'
import type { DateRange } from '../../models/domain/date-range'
import type { DateFilter } from '../../models/store/filters/filter'
import type { CalendarConfigProvider } from '../../providers'
import { defineComponent } from 'vue'
import { CONTAINER } from '../../config'
import { TYPES } from '../../config/inversify.types'
import { DeviceEnum } from '../../enums'
import DateRangePicker from '../date-range-picker/date-range-picker.component.vue'
import { UiModal } from '../keen-ui'
import { EpbButton } from '../shared'

export default defineComponent({
  name: 'CustomDateSelector',
  components: {
    EpbButton,
    UiModal,
    DateRangePicker,
  },
  props: {
    filter: Object as PropType<DateFilter>,
  },
  data() {
    return {
      dateRangeSelectorKey: Math.random(),
      messages: this.$epb.messages.filters,
      dateRange: {
        startDate: undefined,
        endDate: undefined,
      } as DateRange,
      presetDateRangeOptionsComponentTriggered: false,
    }
  },
  computed: {
    modalSize() {
      return this.$epb.device === DeviceEnum.MOBILE ? 'fullscreen' : 'auto'
    },
    isDateRangeValid() {
      return this.dateRange.startDate && this.dateRange.endDate
    },
    presetDateRangeOptionsComponent() {
      const provider = CONTAINER.get<CalendarConfigProvider>(TYPES.CalendarConfigProvider)
      return provider.presetDateRangeOptionsComponent
    },
  },
  methods: {
    open(): void {
      this.initializeDateRange()
      this.$refs.customDateModal.open()
    },
    close(): void {
      this.$refs.customDateModal.close()
      this.resetDateRange()
    },
    onDateRangeSelectorChange(newDateRange: DateRange): void {
      this.presetDateRangeOptionsComponentTriggered = true
      this.dateRange = newDateRange
    },
    onDateRangePickerChange(newDateRange: DateRange): void {
      if (this.presetDateRangeOptionsComponentTriggered) {
        this.dateRangeSelectorKey = Math.random()
        this.presetDateRangeOptionsComponentTriggered = false
      }
      this.dateRange = newDateRange
    },
    onAccept(): void {
      const startDate = this.dateRange.startDate
      const startDateParsed = new Date(
        Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate()),
      )
      const endDate = this.dateRange.endDate
      const endDateParsed = new Date(
        Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate() + 1),
      )
      this.$emit('datesChange', [startDateParsed.getTime(), endDateParsed.getTime()])
      this.close()
    },
    resetDateRange(): void {
      this.dateRangeSelectorKey = Math.random()
      this.dateRange = { startDate: undefined, endDate: undefined }
    },
    initializeDateRange(): void {
      const filter: DateFilter = this.filter
      const [startDateMs, endDateMs] = filter.selectedValues
      if (startDateMs) {
        this.dateRange.startDate = new Date(startDateMs)
      }
      if (endDateMs) {
        const endDate = new Date(endDateMs)
        this.dateRange.endDate = new Date(
          Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate() - 1),
        )
      }
    },
  },
})
